import productInstance from './instance'

const deleteProduct = (productId, callbackSuccess, callbackError) => {

  return async dispatch => {
    productInstance.delete(
      '/products/' + productId,
    )
      .then(() => {
        typeof callbackSuccess === 'function' && callbackSuccess()
      })
      .catch(error => {
        typeof callbackError === 'function' && callbackError(error)
      })
  }
}

export default deleteProduct
